<template>
    <div class="pl-4 pr-4">
        <VueGoodTable :columns="orderColumns"
                      :rows="orders"
                      :pagination-options="{
                        setCurrentPage: query.page,
                        enabled: true,
                      }"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-row-click="viewOrder"
                      :isLoading.sync="loading"
                      :totalRows="total"
                      mode="remote"
                      styleClass="vgt-table"
                      :row-style-class="rowClass"
                      class="vgt-table--card"
        >
            <template slot="table-row" slot-scope="props">
                <!-- Created  -->
                <span v-if="props.column.field === 'created_at'">
                      {{ props.row.created_at | date('YYYY-MM-DD') }}
                </span>
                <!-- Production due at -->
                <span v-else-if="props.column.field === 'production_due_at'">
                      {{ props.row.production_due_at | date('YYYY-MM-DD') }}
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
            </template>
            <div slot="emptystate">
                <div class="page__content page__content--placeholder">
                    <div class="page__content-inner text">
                        <div class="page__content-icon">
                            <AppIcon modifier="cartheader"/>
                        </div>
                        <h2 class="page__content-title">Go make your first order</h2>
                        <p class="text-center">We strongly recommend to make your first order. Then the list will
                            magically appear.</p>
                        <p class="text-center">
                            <router-link :to="{name: 'landing'}" class="button">
                                <span class="button__text">
                                    Browse products
                                </span>
                            </router-link>
                        </p>
                    </div>
                </div>
            </div>
        </VueGoodTable>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { VueGoodTable } from 'vue-good-table';
import Errors from '../../utils/errors';
import { formatDate } from '../../filters/date.filter';
import { dotNotationToNested } from '../../utils/helpers';
import AppIcon from '../AppIcon';

export default {
  components: {
    VueGoodTable,
    AppIcon,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      query: {
        filters: {},
        sort: [],
        page: 1,
        limit: 10,
      },
    };
  },
  filters: {
    date: formatDate,
  },
  computed: {
    ...mapGetters({
      orders: 'orders/userOrders',
      profile: 'profile/profile',
    }),
    ...mapState({
      total: state => state.orders.totalOrders,
      orderId: state => state.orders.orderId,
    }),
    orderColumns() {
      return [
        {
          label: 'Order No',
          field: 'number',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Client ref',
          field: 'client_order_ref',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Status',
          field: 'status.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Created',
          field: 'created_at',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Production due',
          field: 'production_due_at',
          filterOptions: {
            placeholder: 'Filter Due Date',
            enabled: true,
          },
        },
        {
          label: 'User',
          field: 'user.name',
          hidden: !this.profile ? true : this.profile.group_code === 'user-regular',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    rowClass(event) {
      return event.id === this.orderId ? 'is-active' : '';
    },
    viewOrder(event) {
      if (this.$route.params.id === event.row.id) {
        this.$router.push({ name: 'orders' });
        this.$store.commit('orders/orderId', null);
      } else {
        this.$router.push({
          name: 'orders',
          params: { id: event.row.id },
        });
      }
    },
    getOrders() {
      this.loading = true;

      this.$store.dispatch('orders/getUserOrders', this.query)
        .finally(() => {
          this.loading = false;
        });
    },
    updateParams(newProps) {
      this.query = Object.assign({}, this.query, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getOrders();
    },

    onPerPageChange(params) {
      this.updateParams({ limit: params.currentPerPage, page: 1 });
      this.getOrders();
    },

    onSortChange(params) {
      this.updateParams({ sort: params, page: 1 });
      this.getOrders();
    },

    onColumnFilter(params) {
      this.updateParams({ filters: dotNotationToNested(params.columnFilters), page: 1 });
      this.getOrders();
    },
  },
};
</script>
